export const cesFeatureGuids = {
    COSTCOSPSUP: "43f472e7-e9aa-4668-8648-804d952a3513",
    MHB: "efd3b7a3-e7da-4ce2-ab93-7f38ba43365b",
    PHYREMSTPRODUCT: "fd0a9e7b-3609-4320-adeb-0297369b9890",
    MANDIGITALPRODUCT: "9cddf4bc-2a40-46cd-94e9-24d806c54705",
};
